import { render } from "./DeleteConfirmation.vue?vue&type=template&id=c29a66c4&scoped=true"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js"

import "./DeleteConfirmation.vue?vue&type=style&index=0&id=c29a66c4&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29a66c4"]])

export default __exports__